import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: var(--color-bg-default);
  border-radius: 8px;
  display: flex;
  padding: 24px;
  width: 100%;
`;

const LeftSection = styled(ContentLoader)`
  height: 216px;
  width: 280px;
`;

const Divider = styled.div`
  background: var(--color-border-default);
  height: 216px;
  margin: 0 24px;
  width: 1px;
`;

const RightSection = styled(ContentLoader)`
  flex: 1;
  height: 216px;
`;

const ExpandedRecognitionRow = props => (
  <Wrapper>
    <LeftSection speed={2} {...props}>
      <rect x="0" y="0" rx="4" ry="4" width="60" height="16" />
      <rect x="0" y="48" rx="4" ry="4" width="40" height="14" />
      <rect x="180" y="48" rx="4" ry="4" width="80" height="14" />
      <rect x="0" y="88" rx="4" ry="4" width="60" height="14" />
      <rect x="180" y="88" rx="4" ry="4" width="100" height="14" />
      <rect x="0" y="128" rx="4" ry="4" width="90" height="14" />
      <rect x="180" y="128" rx="4" ry="4" width="16" height="16" />
      <rect x="204" y="132" rx="2" ry="2" width="60" height="8" />
    </LeftSection>

    <Divider />

    <RightSection speed={2} {...props}>
      <rect x="0" y="0" rx="4" ry="4" width="120" height="16" />
      <rect x="0" y="24" rx="4" ry="4" width="80" height="12" />

      <rect x="40" y="80" rx="4" ry="4" width="30" height="80" />
      <rect x="120" y="100" rx="4" ry="4" width="30" height="60" />
      <rect x="200" y="70" rx="4" ry="4" width="30" height="90" />
      <rect x="280" y="90" rx="4" ry="4" width="30" height="70" />
      <rect x="360" y="120" rx="4" ry="4" width="30" height="40" />
      <rect x="440" y="95" rx="4" ry="4" width="30" height="65" />
      <rect x="520" y="85" rx="4" ry="4" width="30" height="75" />

      <rect x="35" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="115" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="195" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="275" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="355" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="435" y="170" rx="4" ry="4" width="40" height="12" />
      <rect x="515" y="170" rx="4" ry="4" width="40" height="12" />
    </RightSection>
  </Wrapper>
);

export default ExpandedRecognitionRow;
